import { render } from "./DataTable2.vue?vue&type=template&id=7ef19758&scoped=true"
import script from "./DataTable2.vue?vue&type=script&lang=js"
export * from "./DataTable2.vue?vue&type=script&lang=js"

import "./DataTable2.vue?vue&type=style&index=0&id=7ef19758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef19758"]])

export default __exports__